import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/unified-client/layouts/default.vue")),
  "up-layout": defineAsyncComponent(() => import("/unified-client/layouts/upLayout.vue"))
}